'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.series = exports.getDatapoints = undefined;
var _defineProperty2 = require('babel-runtime/helpers/defineProperty');
var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');
var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
var _split2 = require('lodash/split');
var _split3 = _interopRequireDefault(_split2);
var _isNil2 = require('lodash/isNil');
var _isNil3 = _interopRequireDefault(_isNil2);
var _isEmpty2 = require('lodash/isEmpty');
var _isEmpty3 = _interopRequireDefault(_isEmpty2);
var _head2 = require('lodash/head');
var _head3 = _interopRequireDefault(_head2);
var _sortBy2 = require('lodash/sortBy');
var _sortBy3 = _interopRequireDefault(_sortBy2);
var _map2 = require('lodash/map');
var _map3 = _interopRequireDefault(_map2);
var _dimensionUtils = require('../dimension-utils');
var _observationFormater = require('../observation-formater');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getDatapoints = exports.getDatapoints = function getDatapoints(keys, observations, dimensions, dimensionsWithValuesIndexedById, sortDirection, display, formaterAttrs) {
  var _keys = (0, _slicedToArray3.default)(keys, 2),
    categoryKey = _keys[0],
    valueKey = _keys[1];
  var sortFunc = function sortFunc(dp) {
    return dp[valueKey] * sortDirection;
  };
  return (0, _sortBy3.default)((0, _map3.default)(observations, function (observationValue, observationKey) {
    var _ref;
    var value = (0, _head3.default)(observationValue);
    var category = (0, _dimensionUtils.categoryDisplay)((0, _split3.default)(observationKey, ':'), dimensions, dimensionsWithValuesIndexedById, null, display);
    var categoryIds = (0, _dimensionUtils.categoryDisplay)((0, _split3.default)(observationKey, ':'), dimensions, dimensionsWithValuesIndexedById, null, 'code');
    var formatedValue = (0, _observationFormater.getFormatedObservation)(observationValue, formaterAttrs);
    var key = categoryIds;
    if ((0, _isNil3.default)(key) || (0, _isEmpty3.default)(key)) {
      key = 'uniq-dp';
    }
    return _ref = {
      value: value,
      category: category
    }, (0, _defineProperty3.default)(_ref, valueKey, value), (0, _defineProperty3.default)(_ref, categoryKey, category), (0, _defineProperty3.default)(_ref, 'key', key), (0, _defineProperty3.default)(_ref, 'formatedValue', formatedValue), _ref;
  }), sortFunc);
};
var series = exports.series = function series(keys, observations, dimensions, dimensionsWithValuesIndexedById, sortDirection, display, formaterAttrs) {
  return [{
    datapoints: getDatapoints(keys, observations, dimensions, dimensionsWithValuesIndexedById, sortDirection, display, formaterAttrs)
  }];
};
exports.default = function (chartType, _ref2, dimensionsWithValuesIndexedById, display, formaterAttrs) {
  var observations = _ref2.observations,
    dimensions = _ref2.dimensions;
  switch (chartType) {
    case 'BarChart':
      return series(['x', 'y'], observations, dimensions, dimensionsWithValuesIndexedById, 1, display, formaterAttrs);
    case 'RowChart':
      return series(['y', 'x'], observations, dimensions, dimensionsWithValuesIndexedById, -1, display, formaterAttrs);
    default:
      return [];
  }
};